import { styled, Box, Paper } from "@mui/material";

export const SearchableSelectFieldRoot = styled(Box)(({ theme }) => ({
  position: "relative",
  width: "100%",
}));

export const StyledAutocompletePaper = styled(Paper)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: theme.shadows[4],
  overflow: "hidden",
  "& .MuiAutocomplete-option": {
    borderRadius: theme.shape.borderRadius,
    margin: theme.spacing(0.25, 1),
    padding: theme.spacing(0.75, 1.25),
    alignItems: "flex-start",
    "&[aria-selected='true']": {
      backgroundColor: `${theme.palette.primary.light}33`,
    },
    "&.Mui-focused": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

export const ListFooter = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(1),
  padding: theme.spacing(1, 1.5),
  borderTop: `1px solid ${theme.palette.divider}`,
  color: theme.palette.text.secondary,
  fontSize: "0.75rem",
  backgroundColor: theme.palette.blokko.taglineMist,
}));

export const OptionRow = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(0.25),
  width: "100%",
  paddingTop: theme.spacing(0.25),
  paddingBottom: theme.spacing(0.25),
}));

export const OptionCode = styled("span")(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.primary.main,
  fontSize: "0.875rem",
  letterSpacing: "0.02em",
}));

export const OptionDescription = styled("span")(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: "0.8125rem",
  lineHeight: 1.35,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}));

/** Align Autocomplete outlined input with standard TextField / Select height and corners. */
export const autocompleteFieldSx = (theme) => {
  const radius = `${theme.shape.borderRadius}px`;

  return {
    "& .MuiOutlinedInput-root": {
      borderRadius: radius,
      // MUI Autocomplete shrinks the root with padding: 9 — restore TextField proportions.
      paddingTop: 0,
      paddingBottom: 0,
      paddingLeft: 0,
      "& .MuiOutlinedInput-notchedOutline": {
        borderRadius: radius,
      },
      "& .MuiAutocomplete-input": {
        padding: "16.5px 14px",
      },
    },
  };
};
